import { toast } from '@/components/toast';
import { applyBackgroundColor } from '@/services/images/applyBackgroundColor';
import { VideoType } from '@d-id/types';
import { useMutation } from 'react-query';

export const useApplyBackgroundColor = (
    onSuccessCallback?: ({
        resultUrl,
        backgroundColor,
        videoType,
    }: {
        resultUrl: string;
        backgroundColor: string;
        videoType?: VideoType;
    }) => Promise<void>,
    videoType?: VideoType
) => {
    return useMutation(applyBackgroundColor, {
        onSuccess: async (resultUrl, { backgroundColor }) => {
            if (resultUrl && onSuccessCallback) {
                await onSuccessCallback({ resultUrl, backgroundColor, videoType });
            }
        },
        onError: () => {
            toast.error({ title: 'Failed to apply background color to image, please try again', toastId: `apply-background-color-error` });
        },
    });
};
